"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPLY_DRAFT_ERROR_CODES = exports.TICKET_REPLY_DRAFT_EVENT_TYPE_LABELS = exports.TICKET_REPLY_DRAFT_EVENT_TYPES = void 0;
exports.canSaveReplyDraft = canSaveReplyDraft;
const ticket_messages_js_1 = require("./ticket-messages.js");
/**
 * Evento della cronologia: una bozza di risposta salvata, **senza il testo**. Con l'origine `mcp`
 * sull'evento la cronologia mostra «Bozza di risposta preparata da Mario Rossi via MCP».
 */
exports.TICKET_REPLY_DRAFT_EVENT_TYPES = ['bozza_risposta_preparata'];
exports.TICKET_REPLY_DRAFT_EVENT_TYPE_LABELS = {
    bozza_risposta_preparata: 'Bozza di risposta preparata',
};
/** Codici di errore della bozza di risposta, nel campo `code` del corpo di errore. */
exports.REPLY_DRAFT_ERROR_CODES = {
    /** 409: bozza su un ticket `Risolto`, `Chiuso` o `Scartato` (`details.stato`). */
    draftNotAllowed: 'tickets.bozza_non_ammessa',
};
/**
 * Vero se sul ticket in questo stato si può salvare una bozza di risposta: gli stessi stati da cui si
 * risponde, cioè mai Risolto, Chiuso o Scartato.
 */
function canSaveReplyDraft(state) {
    return (0, ticket_messages_js_1.canReply)(state);
}
//# sourceMappingURL=reply-drafts.js.map